// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hero-carousel {
    width: 100%;
    z-index: 2;
    margin-bottom: 20px;
}

.carousel-container {
    position: relative;
    width: 100%;
    /* Reduzido para melhor visualização e menor ocupação de tela */
    height: 350px;
    overflow: hidden;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.5);
    background-color: var(--background-white);
}

@media (min-width: 1400px) {
    .carousel-container {
        height: 380px;
    }
}

.carousel-slide {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}

.carousel-image {
    width: 100%;
    height: 100%;
    /* Ajustado para caber inteiramente no container sem cortes */
    object-fit: contain;
    object-position: center;
}

.carousel-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(to right,
            rgba(0, 0, 0, 0.7) 0%,
            rgba(0, 0, 0, 0.3) 50%,
            transparent 100%);
    display: flex;
    align-items: center;
    padding: 0 60px;
    z-index: 2;
    pointer-events: none;
    /* Allow clicks to pass through if needed, but buttons have pointer-events: auto */
}

.carousel-content {
    max-width: 600px;
    color: white;
    pointer-events: auto;
}

.carousel-title {
    font-size: 36px;
    font-weight: bold;
    margin: 0 0 12px 0;
    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
    line-height: 1.2;
}

.carousel-subtitle {
    font-size: 18px;
    margin: 0 0 20px 0;
    text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.5);
    line-height: 1.4;
}

.carousel-cta {
    display: inline-block;
    padding: 10px 24px;
    background-color: var(--primary-color);
    color: white;
    text-decoration: none;
    border-radius: var(--radius-sm);
    font-weight: 600;
    font-size: 16px;
    transition: all 0.3s ease;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.carousel-cta:hover {
    background-color: var(--primary-hover);
    transform: translateY(-2px);
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.3);
}

/* Centralização do CTA para o banner inicial de apresentação */
.carousel-overlay.centered {
    justify-content: center;
    align-items: flex-end;
    padding-bottom: 35px;
    background: linear-gradient(to top, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0.1) 40%, transparent 100%);
    pointer-events: none;
}

.carousel-content.centered {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    pointer-events: auto;
}

.initial-banner-wrapper {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 40px 60px 80px 60px;
    background-color: var(--background-white);
}

.carousel-image.initial-logo {
    width: 100%;
    height: 100%;
    max-width: 480px;
    max-height: 160px;
    object-fit: contain;
}

/* Navigation Arrows */
.carousel-arrow {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    background-color: rgba(255, 255, 255, 0.9);
    border: none;
    width: 50px;
    height: 50px;
    border-radius: 50%;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    color: #2d3277;
    transition: all 0.3s ease;
    z-index: 10;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

.carousel-arrow:hover {
    background-color: white;
    transform: translateY(-50%) scale(1.1);
}

.carousel-arrow-left {
    left: 20px;
}

.carousel-arrow-right {
    right: 20px;
}

/* Dots Indicator */
.carousel-dots {
    position: absolute;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    gap: 10px;
    z-index: 10;
}

.carousel-dot {
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background-color: rgba(255, 255, 255, 0.5);
    border: none;
    cursor: pointer;
    transition: all 0.3s ease;
    padding: 0;
}

.carousel-dot.active {
    background-color: white;
    width: 32px;
    border-radius: 6px;
}

.carousel-dot:hover {
    background-color: rgba(255, 255, 255, 0.8);
}

/* Loading State */
.hero-carousel.loading {
    height: 260px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #f5f5f5;
}

.loading-spinner {
    font-size: 18px;
    color: #666;
}

/* Responsive */
@media (max-width: 768px) {
    .carousel-container {
        height: 160px;
    }

    .carousel-overlay {
        padding: 0 30px;
    }

    .carousel-overlay.centered {
        padding-bottom: 12px;
    }

    .initial-banner-wrapper {
        padding: 15px 30px 45px 30px;
    }

    .carousel-image.initial-logo {
        max-width: 240px;
        max-height: 75px;
    }

    .carousel-title {
        font-size: 32px;
    }

    .carousel-subtitle {
        font-size: 18px;
    }

    .carousel-cta {
        padding: 12px 24px;
        font-size: 16px;
    }

    .carousel-arrow {
        width: 40px;
        height: 40px;
        font-size: 16px;
    }

    .carousel-arrow-left {
        left: 10px;
    }

    .carousel-arrow-right {
        right: 10px;
    }
}

@media (max-width: 480px) {
    .carousel-title {
        font-size: 24px;
    }

    .carousel-subtitle {
        font-size: 16px;
        margin-bottom: 20px;
    }

    .carousel-cta {
        padding: 10px 20px;
        font-size: 14px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/HeroCarousel.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,+DAA+D;IAC/D,aAAa;IACb,gBAAgB;IAChB,yCAAyC;IACzC,yCAAyC;AAC7C;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,6DAA6D;IAC7D,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ;;;6BAGyB;IACzB,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,UAAU;IACV,oBAAoB;IACpB,kFAAkF;AACtF;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,2CAA2C;IAC3C,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,2CAA2C;IAC3C,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,sCAAsC;IACtC,YAAY;IACZ,qBAAqB;IACrB,+BAA+B;IAC/B,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,wCAAwC;AAC5C;;AAEA;IACI,sCAAsC;IACtC,2BAA2B;IAC3B,yCAAyC;AAC7C;;AAEA,+DAA+D;AAC/D;IACI,uBAAuB;IACvB,qBAAqB;IACrB,oBAAoB;IACpB,oGAAoG;IACpG,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,4BAA4B;IAC5B,yCAAyC;AAC7C;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA,sBAAsB;AACtB;IACI,kBAAkB;IAClB,QAAQ;IACR,2BAA2B;IAC3B,0CAA0C;IAC1C,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,cAAc;IACd,yBAAyB;IACzB,WAAW;IACX,wCAAwC;AAC5C;;AAEA;IACI,uBAAuB;IACvB,sCAAsC;AAC1C;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;AACf;;AAEA,mBAAmB;AACnB;IACI,kBAAkB;IAClB,YAAY;IACZ,SAAS;IACT,2BAA2B;IAC3B,aAAa;IACb,SAAS;IACT,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,0CAA0C;IAC1C,YAAY;IACZ,eAAe;IACf,yBAAyB;IACzB,UAAU;AACd;;AAEA;IACI,uBAAuB;IACvB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,0CAA0C;AAC9C;;AAEA,kBAAkB;AAClB;IACI,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA,eAAe;AACf;IACI;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,gBAAgB;QAChB,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,kBAAkB;QAClB,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,eAAe;IACnB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,WAAW;IACf;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,kBAAkB;QAClB,eAAe;IACnB;AACJ","sourcesContent":[".hero-carousel {\r\n    width: 100%;\r\n    z-index: 2;\r\n    margin-bottom: 20px;\r\n}\r\n\r\n.carousel-container {\r\n    position: relative;\r\n    width: 100%;\r\n    /* Reduzido para melhor visualização e menor ocupação de tela */\r\n    height: 350px;\r\n    overflow: hidden;\r\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.5);\r\n    background-color: var(--background-white);\r\n}\r\n\r\n@media (min-width: 1400px) {\r\n    .carousel-container {\r\n        height: 380px;\r\n    }\r\n}\r\n\r\n.carousel-slide {\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n}\r\n\r\n.carousel-image {\r\n    width: 100%;\r\n    height: 100%;\r\n    /* Ajustado para caber inteiramente no container sem cortes */\r\n    object-fit: contain;\r\n    object-position: center;\r\n}\r\n\r\n.carousel-overlay {\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    background: linear-gradient(to right,\r\n            rgba(0, 0, 0, 0.7) 0%,\r\n            rgba(0, 0, 0, 0.3) 50%,\r\n            transparent 100%);\r\n    display: flex;\r\n    align-items: center;\r\n    padding: 0 60px;\r\n    z-index: 2;\r\n    pointer-events: none;\r\n    /* Allow clicks to pass through if needed, but buttons have pointer-events: auto */\r\n}\r\n\r\n.carousel-content {\r\n    max-width: 600px;\r\n    color: white;\r\n    pointer-events: auto;\r\n}\r\n\r\n.carousel-title {\r\n    font-size: 36px;\r\n    font-weight: bold;\r\n    margin: 0 0 12px 0;\r\n    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);\r\n    line-height: 1.2;\r\n}\r\n\r\n.carousel-subtitle {\r\n    font-size: 18px;\r\n    margin: 0 0 20px 0;\r\n    text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.5);\r\n    line-height: 1.4;\r\n}\r\n\r\n.carousel-cta {\r\n    display: inline-block;\r\n    padding: 10px 24px;\r\n    background-color: var(--primary-color);\r\n    color: white;\r\n    text-decoration: none;\r\n    border-radius: var(--radius-sm);\r\n    font-weight: 600;\r\n    font-size: 16px;\r\n    transition: all 0.3s ease;\r\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n.carousel-cta:hover {\r\n    background-color: var(--primary-hover);\r\n    transform: translateY(-2px);\r\n    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.3);\r\n}\r\n\r\n/* Centralização do CTA para o banner inicial de apresentação */\r\n.carousel-overlay.centered {\r\n    justify-content: center;\r\n    align-items: flex-end;\r\n    padding-bottom: 35px;\r\n    background: linear-gradient(to top, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0.1) 40%, transparent 100%);\r\n    pointer-events: none;\r\n}\r\n\r\n.carousel-content.centered {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    text-align: center;\r\n    pointer-events: auto;\r\n}\r\n\r\n.initial-banner-wrapper {\r\n    width: 100%;\r\n    height: 100%;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    padding: 40px 60px 80px 60px;\r\n    background-color: var(--background-white);\r\n}\r\n\r\n.carousel-image.initial-logo {\r\n    width: 100%;\r\n    height: 100%;\r\n    max-width: 480px;\r\n    max-height: 160px;\r\n    object-fit: contain;\r\n}\r\n\r\n/* Navigation Arrows */\r\n.carousel-arrow {\r\n    position: absolute;\r\n    top: 50%;\r\n    transform: translateY(-50%);\r\n    background-color: rgba(255, 255, 255, 0.9);\r\n    border: none;\r\n    width: 50px;\r\n    height: 50px;\r\n    border-radius: 50%;\r\n    cursor: pointer;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    font-size: 20px;\r\n    color: #2d3277;\r\n    transition: all 0.3s ease;\r\n    z-index: 10;\r\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n.carousel-arrow:hover {\r\n    background-color: white;\r\n    transform: translateY(-50%) scale(1.1);\r\n}\r\n\r\n.carousel-arrow-left {\r\n    left: 20px;\r\n}\r\n\r\n.carousel-arrow-right {\r\n    right: 20px;\r\n}\r\n\r\n/* Dots Indicator */\r\n.carousel-dots {\r\n    position: absolute;\r\n    bottom: 20px;\r\n    left: 50%;\r\n    transform: translateX(-50%);\r\n    display: flex;\r\n    gap: 10px;\r\n    z-index: 10;\r\n}\r\n\r\n.carousel-dot {\r\n    width: 12px;\r\n    height: 12px;\r\n    border-radius: 50%;\r\n    background-color: rgba(255, 255, 255, 0.5);\r\n    border: none;\r\n    cursor: pointer;\r\n    transition: all 0.3s ease;\r\n    padding: 0;\r\n}\r\n\r\n.carousel-dot.active {\r\n    background-color: white;\r\n    width: 32px;\r\n    border-radius: 6px;\r\n}\r\n\r\n.carousel-dot:hover {\r\n    background-color: rgba(255, 255, 255, 0.8);\r\n}\r\n\r\n/* Loading State */\r\n.hero-carousel.loading {\r\n    height: 260px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    background-color: #f5f5f5;\r\n}\r\n\r\n.loading-spinner {\r\n    font-size: 18px;\r\n    color: #666;\r\n}\r\n\r\n/* Responsive */\r\n@media (max-width: 768px) {\r\n    .carousel-container {\r\n        height: 160px;\r\n    }\r\n\r\n    .carousel-overlay {\r\n        padding: 0 30px;\r\n    }\r\n\r\n    .carousel-overlay.centered {\r\n        padding-bottom: 12px;\r\n    }\r\n\r\n    .initial-banner-wrapper {\r\n        padding: 15px 30px 45px 30px;\r\n    }\r\n\r\n    .carousel-image.initial-logo {\r\n        max-width: 240px;\r\n        max-height: 75px;\r\n    }\r\n\r\n    .carousel-title {\r\n        font-size: 32px;\r\n    }\r\n\r\n    .carousel-subtitle {\r\n        font-size: 18px;\r\n    }\r\n\r\n    .carousel-cta {\r\n        padding: 12px 24px;\r\n        font-size: 16px;\r\n    }\r\n\r\n    .carousel-arrow {\r\n        width: 40px;\r\n        height: 40px;\r\n        font-size: 16px;\r\n    }\r\n\r\n    .carousel-arrow-left {\r\n        left: 10px;\r\n    }\r\n\r\n    .carousel-arrow-right {\r\n        right: 10px;\r\n    }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n    .carousel-title {\r\n        font-size: 24px;\r\n    }\r\n\r\n    .carousel-subtitle {\r\n        font-size: 16px;\r\n        margin-bottom: 20px;\r\n    }\r\n\r\n    .carousel-cta {\r\n        padding: 10px 20px;\r\n        font-size: 14px;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
